<template>
<!--物联网卡号对应的二维码微信支付界面-->
<el-dialog title="物联卡充值二维码" :visible.sync="cardQrcodeVisible" :close-on-click-modal="false" width="30%">
    <qrcode :value="url" class="qrcode"></qrcode>
    <div style="text-align:center;"><span class="iconfont icon-saoma" style="font-size:24px;vertical-align:middle;"></span> &nbsp;&nbsp;请打开 <span class="iconfont icon-weixindenglu" style="font-size:16px;vertical-align:middle;color:#00c800;"></span> <span style="color:#0099cb">微信APP扫码</span> 支付物联网卡费用</div>
</el-dialog>
</template>

<script>
import Qrcode from '@chenfengyuan/vue-qrcode';

export default {
    components: {
        qrcode: Qrcode
    },
    data() {
        return {
            cardQrcodeVisible: false,
            url_prefix: "http://www.yunkawulian.com/mobile/addMoney.html?num=",
            url: "",
            style: {
                //color: { dark: '#0275d8' },
                width: 500
            }
        }
    },
    methods: {
        showCardQrcode(cardno) {
            //console.log("卡号为：" + cardno);
            this.url = this.url_prefix + cardno;
            this.cardQrcodeVisible = true;
        },
        showCardQrcodeWithMonth(cardno,rechargemonth) {
            //console.log("卡号为：" + cardno);
            this.url = this.url_prefix + cardno +'&rechargemonth='+rechargemonth;
            this.cardQrcodeVisible = true;
        }
    }
}
</script>

<style>
.qrcode {
    width: 100% !important;
    height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// card_qrcode.vue?ec00795a